import { dashboardApiMiddleware } from "../api.middlewares";
import { GetResourceInfoResponse } from "./resource.interface";

export const getResourceInfo = dashboardApiMiddleware<GetResourceInfoResponse>()({
  method: "get",
  endpoint: "/api/link/resource/info/:uuid",
});
